import { API_URL, API_VERSIONS } from "@/constants/environment.constants";

import { customFetch } from "./customFetch/customFetch";

import { RestLink } from "apollo-link-rest";
import camelCase from "camelcase";
import camelcaseKeys from "camelcase-keys";
import { snakeCase } from "snake-case";

interface BodySerializerFnReturn {
  body: string;
  headers: Headers;
}

/**
 * Serialize body to camel case
 * @param data - Body data
 * @param headers - Headers
 * @returns An object with the headers and body serialized to camel case
 */
export function camelCaseBodySerializer(
  data: Record<string, any>,
  headers: Headers
): BodySerializerFnReturn {
  headers.set("content-type", "application/json");
  const transformedData = camelcaseKeys(data, { deep: true });
  return { body: JSON.stringify(transformedData), headers };
}

export function authBodySerializer(
  data: Record<string, any>,
  headers: Headers
): BodySerializerFnReturn {
  headers.set("Aircall-Platform", "dashboard-v4");
  return camelCaseBodySerializer(data, headers);
}

/**
 * Uses apollo-link-rest to help us transform
 * the RESTful API as GraphQL API.
 */
export const restLink = new RestLink({
  uri: API_URL,
  endpoints: {
    v3: API_URL + API_VERSIONS.v3,
  },
  customFetch,
  fieldNameNormalizer: (fieldName: string) =>
    fieldName === "ID" ? fieldName : camelCase(fieldName),
  fieldNameDenormalizer: (fieldName: string) => snakeCase(fieldName),
  bodySerializers: {
    auth: authBodySerializer,
    camelCase: camelCaseBodySerializer,
  },
});
